var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestionMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 2,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 30.5C14.201 30.5 9.5 25.799 9.5 20C9.5 14.201 14.201 9.5 20 9.5C25.799 9.5 30.5 14.201 30.5 20C30.5 25.799 25.799 30.5 20 30.5ZM20 32C26.6274 32 32 26.6274 32 20C32 13.3726 26.6274 8 20 8C13.3726 8 8 13.3726 8 20C8 26.6274 13.3726 32 20 32Z",
    fill: "#2362A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8827 16.6792C15.8713 16.8835 16.0399 17.0491 16.2445 17.0491H17.4812C17.6883 17.0491 17.853 16.8802 17.8808 16.675C18.0143 15.6908 18.6898 14.9734 19.8938 14.9734C20.9221 14.9734 21.8648 15.4875 21.8648 16.7253C21.8648 17.6775 21.303 18.1155 20.4175 18.782C19.4082 19.5151 18.6084 20.3721 18.6656 21.7622L18.67 22.0874C18.6728 22.2925 18.8399 22.4573 19.045 22.4573H20.2615C20.4686 22.4573 20.6365 22.2894 20.6365 22.0823V21.9241C20.6365 20.8481 21.0459 20.5339 22.1504 19.696C23.0645 19.001 24.0166 18.2297 24.0166 16.6111C24.0166 14.345 22.1028 13.25 20.0081 13.25C18.1075 13.25 16.0245 14.1359 15.8827 16.6792ZM18.218 25.3232C18.218 26.123 18.856 26.7134 19.732 26.7134C20.646 26.7134 21.2744 26.123 21.2744 25.3232C21.2744 24.4949 20.646 23.9141 19.732 23.9141C18.856 23.9141 18.218 24.4949 18.218 25.3232Z",
    fill: "#2362A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionMark);
export default __webpack_public_path__ + "static/media/question_mark.6d96a7c50e87a077ac09bc4278fd5ff2.svg";
export { ForwardRef as ReactComponent };